var map = {
	"./zz1.png": 9581,
	"./zz2.png": 4694,
	"./zz3.png": 3711,
	"./zz4.png": 864,
	"./zz5.png": 7769,
	"./zz6.png": 3234,
	"./zz7.png": 4363,
	"./zz8.png": 764,
	"./zz9.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2557;